import { getField } from 'vuex-map-fields';

export default {
  loadingInstantReplies: state => state.loadingInstantReplies,
  instantReplyList: state => state.instantReplyList,
  instantReply: state => state.instantReply,
  instantReplySaved: state => state.instantReplySaved,
  instantReplyDeleted: state => state.instantReplyDeleted,
  instantReplyMessageDeleted: state => state.instantReplyMessageDeleted,
  keywordAnalytics: state => state.keywordAnalytics,

  automationRules: state => state.automationRules,
  automationRulesLoaded: state => state.automationRulesLoaded,
  automationRuleSaved: state => state.automationRuleSaved,
  automationRuleDeleted: state => state.automationRuleDeleted,

  automationSettings: state => state.automationSettings,
  automationSettingsSaved: state => state.automationSettingsSaved,
  unsubscribeMessageSaved: state => state.unsubscribeMessageSaved,
  uploadedFile: state => state.uploadedFile,
  apiError: state => state.apiError,
  fileUploadError: state => state.fileUploadError,
  getField,
};
